require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/catalog/legacy/product-details.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/catalog/legacy/product-details.legacy.js
// module id = 179
// module chunks = 32 34